import { render } from "./CategoriesListCategory.vue?vue&type=template&id=cdc50f18"
import script from "./CategoriesListCategory.vue?vue&type=script&lang=js"
export * from "./CategoriesListCategory.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__